var Me = Object.defineProperty;
var Ie = (a, t, e) =>
  t in a
    ? Me(a, t, { enumerable: !0, configurable: !0, writable: !0, value: e })
    : (a[t] = e);
var C = (a, t, e) => Ie(a, typeof t != "symbol" ? t + "" : t, e);
import { E as le } from "./events.Dnaewmpi.min.js";
import { S as J, Z as Se } from "./swiper-slider.BC0cm2F6.min.js";
import { S as Ce } from "./sections-api-service.smvSsykG.min.js";
import { p as Ae } from "./parse-html.C-hh7jJd.min.js";
import { c as xe } from "./create-css-variable.CHZ2_0r7.min.js";
import { N as de, P as Le } from "./pagination.CSB8jy1x.min.js";
import { A as he } from "./a11y.D_ql501b.min.js";
import { f as Pe, T as Te } from "./free-mode.q24ti9bJ.min.js";
import "./swiper-core.G3YmVjfP.min.js";
import "./autoplay.Bk0Xs_DJ.min.js";
var g = function () {
  return (
    (g =
      Object.assign ||
      function (t) {
        for (var e, n = 1, s = arguments.length; n < s; n++) {
          e = arguments[n];
          for (var c in e)
            Object.prototype.hasOwnProperty.call(e, c) && (t[c] = e[c]);
        }
        return t;
      }),
    g.apply(this, arguments)
  );
};
typeof window < "u" &&
  (window.NodeList &&
    !NodeList.prototype.forEach &&
    (NodeList.prototype.forEach = Array.prototype.forEach),
  typeof window.CustomEvent != "function" &&
    (window.CustomEvent = function (t, e) {
      e = e || { bubbles: !1, cancelable: !1, detail: null };
      var n = document.createEvent("CustomEvent");
      return (n.initCustomEvent(t, e.bubbles, e.cancelable, e.detail), n);
    }));
var ze = typeof document < "u" && !!document.documentMode,
  K;
function Oe() {
  return K || (K = document.createElement("div").style);
}
var ce = ["webkit", "moz", "ms"],
  X = {};
function ie(a) {
  if (X[a]) return X[a];
  var t = Oe();
  if (a in t) return (X[a] = a);
  for (var e = a[0].toUpperCase() + a.slice(1), n = ce.length; n--; ) {
    var s = "".concat(ce[n]).concat(e);
    if (s in t) return (X[a] = s);
  }
}
function G(a, t) {
  return parseFloat(t[ie(a)]) || 0;
}
function Y(a, t, e) {
  e === void 0 && (e = window.getComputedStyle(a));
  var n = t === "border" ? "Width" : "";
  return {
    left: G("".concat(t, "Left").concat(n), e),
    right: G("".concat(t, "Right").concat(n), e),
    top: G("".concat(t, "Top").concat(n), e),
    bottom: G("".concat(t, "Bottom").concat(n), e),
  };
}
function A(a, t, e) {
  a.style[ie(t)] = e;
}
function ke(a, t) {
  var e = ie("transform");
  A(
    a,
    "transition",
    "".concat(e, " ").concat(t.duration, "ms ").concat(t.easing),
  );
}
function Ze(a, t, e) {
  var n = t.x,
    s = t.y,
    c = t.scale,
    u = t.isSVG;
  if (
    (A(
      a,
      "transform",
      "scale(".concat(c, ") translate(").concat(n, "px, ").concat(s, "px)"),
    ),
    u && ze)
  ) {
    var l = window.getComputedStyle(a).getPropertyValue("transform");
    a.setAttribute("transform", l);
  }
}
function Q(a) {
  var t = a.parentNode,
    e = window.getComputedStyle(a),
    n = window.getComputedStyle(t),
    s = a.getBoundingClientRect(),
    c = t.getBoundingClientRect();
  return {
    elem: {
      style: e,
      width: s.width,
      height: s.height,
      top: s.top,
      bottom: s.bottom,
      left: s.left,
      right: s.right,
      margin: Y(a, "margin", e),
      border: Y(a, "border", e),
    },
    parent: {
      style: n,
      width: c.width,
      height: c.height,
      top: c.top,
      bottom: c.bottom,
      left: c.left,
      right: c.right,
      padding: Y(t, "padding", n),
      border: Y(t, "border", n),
    },
  };
}
var T = { down: "mousedown", move: "mousemove", up: "mouseup mouseleave" };
typeof window < "u" &&
  (typeof window.PointerEvent == "function"
    ? (T = {
        down: "pointerdown",
        move: "pointermove",
        up: "pointerup pointerleave pointercancel",
      })
    : typeof window.TouchEvent == "function" &&
      (T = {
        down: "touchstart",
        move: "touchmove",
        up: "touchend touchcancel",
      }));
function ee(a, t, e, n) {
  T[a].split(" ").forEach(function (s) {
    t.addEventListener(s, e, n);
  });
}
function te(a, t, e) {
  T[a].split(" ").forEach(function (n) {
    t.removeEventListener(n, e);
  });
}
function fe(a, t) {
  for (var e = a.length; e--; ) if (a[e].pointerId === t.pointerId) return e;
  return -1;
}
function ne(a, t) {
  var e;
  if (t.touches) {
    e = 0;
    for (var n = 0, s = t.touches; n < s.length; n++) {
      var c = s[n];
      ((c.pointerId = e++), ne(a, c));
    }
    return;
  }
  ((e = fe(a, t)), e > -1 && a.splice(e, 1), a.push(t));
}
function _e(a, t) {
  if (t.touches) {
    for (; a.length; ) a.pop();
    return;
  }
  var e = fe(a, t);
  e > -1 && a.splice(e, 1);
}
function me(a) {
  a = a.slice(0);
  for (var t = a.pop(), e; (e = a.pop()); )
    t = {
      clientX: (e.clientX - t.clientX) / 2 + t.clientX,
      clientY: (e.clientY - t.clientY) / 2 + t.clientY,
    };
  return t;
}
function ae(a) {
  if (a.length < 2) return 0;
  var t = a[0],
    e = a[1];
  return Math.sqrt(
    Math.pow(Math.abs(e.clientX - t.clientX), 2) +
      Math.pow(Math.abs(e.clientY - t.clientY), 2),
  );
}
function De(a) {
  for (var t = a; t && t.parentNode; ) {
    if (t.parentNode === document) return !0;
    t = t.parentNode instanceof ShadowRoot ? t.parentNode.host : t.parentNode;
  }
  return !1;
}
function Re(a) {
  return (a.getAttribute("class") || "").trim();
}
function Xe(a, t) {
  return (
    a.nodeType === 1 && " ".concat(Re(a), " ").indexOf(" ".concat(t, " ")) > -1
  );
}
function Ge(a, t) {
  for (var e = a; e != null; e = e.parentNode)
    if (Xe(e, t.excludeClass) || t.exclude.indexOf(e) > -1) return !0;
  return !1;
}
var Ye = /^http:[\w\.\/]+svg$/;
function Ne(a) {
  return Ye.test(a.namespaceURI) && a.nodeName.toLowerCase() !== "svg";
}
function qe(a) {
  var t = {};
  for (var e in a) a.hasOwnProperty(e) && (t[e] = a[e]);
  return t;
}
var pe = {
  animate: !1,
  canvas: !1,
  cursor: "move",
  disablePan: !1,
  disableZoom: !1,
  disableXAxis: !1,
  disableYAxis: !1,
  duration: 200,
  easing: "ease-in-out",
  exclude: [],
  excludeClass: "panzoom-exclude",
  handleStartEvent: function (a) {
    (a.preventDefault(), a.stopPropagation());
  },
  maxScale: 4,
  minScale: 0.125,
  overflow: "hidden",
  panOnlyWhenZoomed: !1,
  pinchAndPan: !1,
  relative: !1,
  setTransform: Ze,
  startX: 0,
  startY: 0,
  startScale: 1,
  step: 0.3,
  touchAction: "none",
};
function ge(a, t) {
  if (!a) throw new Error("Panzoom requires an element as an argument");
  if (a.nodeType !== 1)
    throw new Error("Panzoom requires an element with a nodeType of 1");
  if (!De(a))
    throw new Error(
      "Panzoom should be called on elements that have been attached to the DOM",
    );
  t = g(g({}, pe), t);
  var e = Ne(a),
    n = a.parentNode;
  ((n.style.overflow = t.overflow),
    (n.style.userSelect = "none"),
    (n.style.touchAction = t.touchAction),
    ((t.canvas ? n : a).style.cursor = t.cursor),
    (a.style.userSelect = "none"),
    (a.style.touchAction = t.touchAction),
    A(
      a,
      "transformOrigin",
      typeof t.origin == "string" ? t.origin : e ? "0 0" : "50% 50%",
    ));
  function s() {
    ((n.style.overflow = ""),
      (n.style.userSelect = ""),
      (n.style.touchAction = ""),
      (n.style.cursor = ""),
      (a.style.cursor = ""),
      (a.style.userSelect = ""),
      (a.style.touchAction = ""),
      A(a, "transformOrigin", ""));
  }
  function c(i) {
    i === void 0 && (i = {});
    for (var o in i) i.hasOwnProperty(o) && (t[o] = i[o]);
    ((i.hasOwnProperty("cursor") || i.hasOwnProperty("canvas")) &&
      ((n.style.cursor = a.style.cursor = ""),
      ((t.canvas ? n : a).style.cursor = t.cursor)),
      i.hasOwnProperty("overflow") && (n.style.overflow = i.overflow),
      i.hasOwnProperty("touchAction") &&
        ((n.style.touchAction = i.touchAction),
        (a.style.touchAction = i.touchAction)));
  }
  var u = 0,
    l = 0,
    m = 1,
    b = !1;
  (O(t.startScale, { animate: !1, force: !0 }),
    setTimeout(function () {
      N(t.startX, t.startY, { animate: !1, force: !0 });
    }));
  function M(i, o, h) {
    if (!h.silent) {
      var p = new CustomEvent(i, { detail: o });
      a.dispatchEvent(p);
    }
  }
  function E(i, o, h) {
    var p = { x: u, y: l, scale: m, isSVG: e, originalEvent: h };
    return (
      requestAnimationFrame(function () {
        (typeof o.animate == "boolean" &&
          (o.animate ? ke(a, o) : A(a, "transition", "none")),
          o.setTransform(a, p, o),
          M(i, p, o),
          M("panzoomchange", p, o));
      }),
      p
    );
  }
  function x(i, o, h, p) {
    var r = g(g({}, t), p),
      f = { x: u, y: l, opts: r };
    if (
      !r.force &&
      (r.disablePan || (r.panOnlyWhenZoomed && m === r.startScale))
    )
      return f;
    if (
      ((i = parseFloat(i)),
      (o = parseFloat(o)),
      r.disableXAxis || (f.x = (r.relative ? u : 0) + i),
      r.disableYAxis || (f.y = (r.relative ? l : 0) + o),
      r.contain)
    ) {
      var d = Q(a),
        v = d.elem.width / m,
        w = d.elem.height / m,
        L = v * h,
        P = w * h,
        I = (L - v) / 2,
        S = (P - w) / 2;
      if (r.contain === "inside") {
        var H = (-d.elem.margin.left - d.parent.padding.left + I) / h,
          $ =
            (d.parent.width -
              L -
              d.parent.padding.left -
              d.elem.margin.left -
              d.parent.border.left -
              d.parent.border.right +
              I) /
            h;
        f.x = Math.max(Math.min(f.x, $), H);
        var F = (-d.elem.margin.top - d.parent.padding.top + S) / h,
          j =
            (d.parent.height -
              P -
              d.parent.padding.top -
              d.elem.margin.top -
              d.parent.border.top -
              d.parent.border.bottom +
              S) /
            h;
        f.y = Math.max(Math.min(f.y, j), F);
      } else if (r.contain === "outside") {
        var H =
            (-(L - d.parent.width) -
              d.parent.padding.left -
              d.parent.border.left -
              d.parent.border.right +
              I) /
            h,
          $ = (I - d.parent.padding.left) / h;
        f.x = Math.max(Math.min(f.x, $), H);
        var F =
            (-(P - d.parent.height) -
              d.parent.padding.top -
              d.parent.border.top -
              d.parent.border.bottom +
              S) /
            h,
          j = (S - d.parent.padding.top) / h;
        f.y = Math.max(Math.min(f.y, j), F);
      }
    }
    return (
      r.roundPixels && ((f.x = Math.round(f.x)), (f.y = Math.round(f.y))),
      f
    );
  }
  function z(i, o) {
    var h = g(g({}, t), o),
      p = { scale: m, opts: h };
    if (!h.force && h.disableZoom) return p;
    var r = t.minScale,
      f = t.maxScale;
    if (h.contain) {
      var d = Q(a),
        v = d.elem.width / m,
        w = d.elem.height / m;
      if (v > 1 && w > 1) {
        var L = d.parent.width - d.parent.border.left - d.parent.border.right,
          P = d.parent.height - d.parent.border.top - d.parent.border.bottom,
          I = L / v,
          S = P / w;
        t.contain === "inside"
          ? (f = Math.min(f, I, S))
          : t.contain === "outside" && (r = Math.max(r, I, S));
      }
    }
    return ((p.scale = Math.min(Math.max(i, r), f)), p);
  }
  function N(i, o, h, p) {
    var r = x(i, o, m, h);
    return u !== r.x || l !== r.y
      ? ((u = r.x), (l = r.y), E("panzoompan", r.opts, p))
      : { x: u, y: l, scale: m, isSVG: e, originalEvent: p };
  }
  function O(i, o, h) {
    var p = z(i, o),
      r = p.opts;
    if (!(!r.force && r.disableZoom)) {
      i = p.scale;
      var f = u,
        d = l;
      if (r.focal) {
        var v = r.focal;
        ((f = (v.x / i - v.x / m + u * i) / i),
          (d = (v.y / i - v.y / m + l * i) / i));
      }
      var w = x(f, d, i, { relative: !1, force: !0 });
      return ((u = w.x), (l = w.y), (m = i), E("panzoomzoom", r, h));
    }
  }
  function re(i, o) {
    var h = g(g(g({}, t), { animate: !0 }), o);
    return O(m * Math.exp((i ? 1 : -1) * h.step), h);
  }
  function ve(i) {
    return re(!0, i);
  }
  function ye(i) {
    return re(!1, i);
  }
  function q(i, o, h, p) {
    var r = Q(a),
      f = {
        width:
          r.parent.width -
          r.parent.padding.left -
          r.parent.padding.right -
          r.parent.border.left -
          r.parent.border.right,
        height:
          r.parent.height -
          r.parent.padding.top -
          r.parent.padding.bottom -
          r.parent.border.top -
          r.parent.border.bottom,
      },
      d =
        o.clientX -
        r.parent.left -
        r.parent.padding.left -
        r.parent.border.left -
        r.elem.margin.left,
      v =
        o.clientY -
        r.parent.top -
        r.parent.padding.top -
        r.parent.border.top -
        r.elem.margin.top;
    e || ((d -= r.elem.width / m / 2), (v -= r.elem.height / m / 2));
    var w = {
      x: (d / f.width) * (f.width * i),
      y: (v / f.height) * (f.height * i),
    };
    return O(i, g(g({}, h), { animate: !1, focal: w }), p);
  }
  function we(i, o) {
    i.preventDefault();
    var h = g(g(g({}, t), o), { animate: !1 }),
      p = i.deltaY === 0 && i.deltaX ? i.deltaX : i.deltaY,
      r = p < 0 ? 1 : -1,
      f = z(m * Math.exp((r * h.step) / 3), h).scale;
    return q(f, i, h, i);
  }
  function be(i) {
    var o = g(g(g({}, t), { animate: !0, force: !0 }), i);
    m = z(o.startScale, o).scale;
    var h = x(o.startX, o.startY, m, o);
    return ((u = h.x), (l = h.y), E("panzoomreset", o));
  }
  var k,
    Z,
    _,
    D,
    oe,
    R,
    y = [];
  function B(i) {
    if (!Ge(i.target, t)) {
      (ne(y, i),
        (b = !0),
        t.handleStartEvent(i),
        (k = u),
        (Z = l),
        M(
          "panzoomstart",
          { x: u, y: l, scale: m, isSVG: e, originalEvent: i },
          t,
        ));
      var o = me(y);
      ((_ = o.clientX), (D = o.clientY), (oe = m), (R = ae(y)));
    }
  }
  function V(i) {
    if (!(!b || k === void 0 || Z === void 0 || _ === void 0 || D === void 0)) {
      ne(y, i);
      var o = me(y),
        h = y.length > 1,
        p = m;
      if (h) {
        R === 0 && (R = ae(y));
        var r = ae(y) - R;
        ((p = z((r * t.step) / 80 + oe).scale), q(p, o, { animate: !1 }, i));
      }
      (!h || t.pinchAndPan) &&
        N(k + (o.clientX - _) / p, Z + (o.clientY - D) / p, { animate: !1 }, i);
    }
  }
  function U(i) {
    (y.length === 1 &&
      M("panzoomend", { x: u, y: l, scale: m, isSVG: e, originalEvent: i }, t),
      _e(y, i),
      b && ((b = !1), (k = Z = _ = D = void 0)));
  }
  var W = !1;
  function se() {
    W ||
      ((W = !0),
      ee("down", t.canvas ? n : a, B),
      ee("move", document, V, { passive: !0 }),
      ee("up", document, U, { passive: !0 }));
  }
  function Ee() {
    ((W = !1),
      te("down", t.canvas ? n : a, B),
      te("move", document, V),
      te("up", document, U));
  }
  return (
    t.noBind || se(),
    {
      bind: se,
      destroy: Ee,
      eventNames: T,
      getPan: function () {
        return { x: u, y: l };
      },
      getScale: function () {
        return m;
      },
      getOptions: function () {
        return qe(t);
      },
      handleDown: B,
      handleMove: V,
      handleUp: U,
      pan: N,
      reset: be,
      resetStyle: s,
      setOptions: c,
      setStyle: function (i, o) {
        return A(a, i, o);
      },
      zoom: O,
      zoomIn: ve,
      zoomOut: ye,
      zoomToPoint: q,
      zoomWithWheel: we,
    }
  );
}
ge.defaultOptions = pe;
const Be = () => window.innerWidth > 768,
  ue = [
    "mousedown",
    "mousemove",
    "mouseup",
    "touchstart",
    "touchmove",
    "touchend",
  ];
class Ve extends HTMLElement {
  constructor() {
    super();
    C(this, "lastUserTap", 0);
    C(this, "DOUBLE_TAP_THRESHOLD", 300);
    C(this, "ZOOM_EXIT_THRESHOLD", 5);
    C(this, "ZOOM_DRAGGING", !1);
    C(this, "ZOOM_DRAG_X", 0);
    C(this, "ZOOM_DRAG_Y", 0);
    ((this.mainSwiperWrapperEl = this.querySelector(
      "[data-main-swiper-container]",
    )),
      (this.thumbnailsSwiperWrapperEl = this.querySelector(
        "[data-thumbnails-swiper-container]",
      )),
      (this.variantImageContainerEl = this.querySelector(
        ".js-standard-gallery-variant-image-container",
      )),
      (this.mobileBreakpoint = 769),
      (this.modal = this.querySelector(".main-product__media-modal")),
      (this.modalImageContainer = this.querySelector(
        ".main-product__media-modal-image-container",
      )),
      (this.modalZoomImageContainer = this.querySelector(
        ".main-product__media-modal-image-container-zoom",
      )),
      (this.modalZoomImage = this.querySelector(
        ".main-product__media-modal-image-zoom",
      )),
      (this.modalImages = [
        ...this.querySelectorAll(".main-product__media-modal-image"),
      ]),
      (this.modalImage = this.querySelector(
        ".main-product__media-modal-image",
      )),
      (this.modalClose = this.querySelector(
        ".main-product__media-modal-close",
      )),
      (this.modalThumbnails = this.querySelectorAll("[data-modal-thumbnail]")),
      (this.header = document.querySelector("dickies-header .header")),
      (this.loadMoreBtn = this.querySelector(
        ".dickies-standard-gallery__load-more-cta",
      )),
      (this.handleImageClick = this.handleImageClick.bind(this)),
      (this.closeModal = this.closeModal.bind(this)),
      (this.handleModalClick = this.handleModalClick.bind(this)),
      (this.handleModalImageClick = this.handleModalImageClick.bind(this)),
      (this.handleModalImageMouseMove =
        this.handleModalImageMouseMove.bind(this)),
      (this.handleModalImageMouseLeave =
        this.handleModalImageMouseLeave.bind(this)),
      (this.handleThumbnailClick = this.handleThumbnailClick.bind(this)),
      (this.handleZoomImageClick = this.handleZoomImageClick.bind(this)),
      (this.handleZoomImageMouseEvents =
        this.handleZoomImageMouseEvents.bind(this)),
      (this.handleLoadMoreBtn = this.handleLoadMoreBtn.bind(this)));
  }
  connectedCallback() {
    var n, s, c, u;
    if (
      !this.mainSwiperWrapperEl ||
      !this.thumbnailsSwiperWrapperEl ||
      typeof J > "u"
    ) {
      (console.warn(
        "MainProductStandardGallery: Essential Swiper elements not found or Swiper library not loaded.",
      ),
        (this.style.opacity = "1"));
      return;
    }
    (this.header.classList.contains("is-transparent") &&
      this.style.setProperty(
        "--custom-gallery-padding-top",
        "var(--dickies-announcement-banner-height-static)",
      ),
      this.initSwipers(),
      this.handleResize(),
      window.addEventListener("load", this.handleResize.bind(this)),
      window.addEventListener("resize", this.handleResize.bind(this)),
      this.addEventListener(
        le.PRODUCT_VARIANT_UPDATE,
        this.handleProductVariantUpdate.bind(this),
      ),
      this.querySelectorAll(".product-media-gallery__button").forEach((l) => {
        l.addEventListener("click", this.handleImageClick);
      }),
      (n = this.modalClose) == null ||
        n.addEventListener("click", this.handleModalClose.bind(this)),
      (s = this.modal) == null ||
        s.addEventListener("click", this.handleModalClick),
      (c = this.loadMoreBtn) == null ||
        c.addEventListener("click", this.handleLoadMoreBtn),
      (u = this.modalThumbnails) == null ||
        u.forEach((l) => {
          l.addEventListener("click", this.handleThumbnailClick);
        }),
      document.addEventListener("keydown", (l) => {
        l.key === "Escape" && this.closeModal();
      }));
    const e = new IntersectionObserver(
      (l) => {
        l.forEach((m) => {
          if (m.isIntersecting) {
            const b = m.target.dataset.imageIndex;
            this.setActiveThumbnail(b);
          }
        });
      },
      { threshold: 0.25 },
    );
    (this.modalImages.forEach((l) => {
      (e.observe(l), l.addEventListener("click", this.handleModalImageClick));
    }),
      ue.forEach((l) => {
        this.modalZoomImage.addEventListener(
          l,
          this.handleZoomImageMouseEvents,
        );
      }));
  }
  disconnectedCallback() {
    var e, n, s, c, u;
    (this.swiper &&
      typeof this.swiper.destroy == "function" &&
      this.swiper.destroy(!0, !0),
      this.thumbnailsSwiper &&
        typeof this.thumbnailsSwiper.destroy == "function" &&
        this.thumbnailsSwiper.destroy(!0, !0),
      window.removeEventListener("resize", this.handleResize.bind(this)),
      this.removeEventListener(
        le.PRODUCT_VARIANT_UPDATE,
        this.handleProductVariantUpdate.bind(this),
      ),
      this.querySelectorAll(".product-media-gallery__button").forEach((l) => {
        l.removeEventListener("click", this.handleImageClick);
      }),
      (e = this.modalClose) == null ||
        e.removeEventListener("click", this.handleModalClose.bind(this)),
      (n = this.modal) == null ||
        n.removeEventListener("click", this.handleModalClick),
      (s = this.loadMoreBtn) == null ||
        s.removeEventListener("click", this.handleLoadMoreBtn),
      (c = this.modalThumbnails) == null ||
        c.forEach((l) => {
          l.removeEventListener("click", this.handleThumbnailClick);
        }),
      (u = this.modalImages) == null ||
        u.forEach((l) => {
          l.removeEventListener("click", this.handleModalImageClick);
        }),
      ue.forEach((l) => {
        this.modalZoomImage.removeEventListener(
          l,
          this.handleZoomImageMouseEvents,
        );
      }));
  }
  setLazyImages() {
    this.modalImages.forEach((e) => {
      e.src = e.getAttribute("data-src");
    });
  }
  handleLoadMoreBtn(e) {
    this.classList.toggle("truncated");
  }
  setActiveThumbnail(e) {
    const n = Array.from(this.modalThumbnails).find(
      (s) => Number(s.getAttribute("data-image-index")) === Number(e),
    );
    (this.modalThumbnails.forEach((s) => {
      s.removeAttribute("data-active");
    }),
      n &&
        (n.setAttribute("data-active", "true"),
        n.scrollIntoView({ behavior: "smooth", block: "center" })));
  }
  handleModalImageClick(e) {
    var c;
    e.stopPropagation();
    const n = this.modal.getAttribute("data-zoomed") === "true",
      s = e.target.src;
    s &&
      ((this.modalZoomImage.src = s),
      n
        ? (this.modalZoomImage.removeEventListener(
            "wheel",
            this.galleryPanzoom.zoomWithWheel,
          ),
          this.modalZoomImage.removeEventListener(
            "mousedown",
            this.galleryPanzoom.handleDown,
          ),
          this.modalZoomImage.removeEventListener(
            "mousemove",
            this.galleryPanzoom.handleMove,
          ),
          this.modalZoomImage.removeEventListener(
            "mouseup",
            this.galleryPanzoom.handleUp,
          ),
          this.modalZoomImage.removeEventListener(
            "touchstart",
            this.galleryPanzoom.handleDown,
          ),
          this.modalZoomImage.removeEventListener(
            "touchmove",
            this.galleryPanzoom.handleMove,
          ),
          this.modalZoomImage.removeEventListener(
            "touchend",
            this.galleryPanzoom.handleUp,
          ),
          (c = this.galleryPanzoom) == null || c.destroy())
        : ((this.galleryPanzoom = ge(this.modalZoomImage, {
            maxScale: 5,
            minScale: 1,
            contain: "outside",
            pinchAndPan: !0,
            noBind: !0,
            startScale: Be() ? 3 : 5,
          })),
          this.modalZoomImage.addEventListener(
            "wheel",
            this.galleryPanzoom.zoomWithWheel,
          ),
          this.modalZoomImage.addEventListener(
            "mousedown",
            this.galleryPanzoom.handleDown,
          ),
          this.modalZoomImage.addEventListener(
            "mousemove",
            this.galleryPanzoom.handleMove,
          ),
          this.modalZoomImage.addEventListener(
            "mouseup",
            this.galleryPanzoom.handleUp,
          ),
          this.modalZoomImage.addEventListener(
            "touchstart",
            this.galleryPanzoom.handleDown,
          ),
          this.modalZoomImage.addEventListener(
            "touchmove",
            this.galleryPanzoom.handleMove,
          ),
          this.modalZoomImage.addEventListener(
            "touchend",
            this.galleryPanzoom.handleUp,
          )),
      this.modal.setAttribute("data-zoomed", String(!n)));
  }
  getEventCoords(e) {
    return e.touches && e.touches.length > 0
      ? { x: e.touches[0].clientX, y: e.touches[0].clientY }
      : e.changedTouches && e.changedTouches.length > 0
        ? { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY }
        : { x: e.clientX, y: e.clientY };
  }
  handleZoomImageMouseEvents(e) {
    const { x: n, y: s } = this.getEventCoords(e);
    if (e.type === "mousedown" || e.type === "touchstart") {
      ((this.ZOOM_DRAG_X = n),
        (this.ZOOM_DRAG_Y = s),
        (this.ZOOM_DRAGGING = !1));
      return;
    }
    if (e.type === "mousemove" || e.type === "touchmove") {
      const c = Math.abs(n - this.ZOOM_DRAG_X),
        u = Math.abs(s - this.ZOOM_DRAG_Y);
      (c > this.ZOOM_EXIT_THRESHOLD || u > this.ZOOM_EXIT_THRESHOLD) &&
        (this.ZOOM_DRAGGING = !0);
      return;
    }
    if (e.type === "mouseup" || e.type === "touchend") {
      if (this.ZOOM_DRAGGING) return;
      (this.modal.setAttribute("data-zoomed", "false"),
        (this.modalZoomImage.src = ""));
    }
  }
  handleZoomImageClick(e) {
    (e.stopPropagation(),
      e.preventDefault(),
      this.modal.setAttribute("data-zoomed", "false"),
      (this.modalZoomImage.src = ""));
  }
  handleModalImageMouseMove(e) {
    if (this.modal.getAttribute("data-zoomed") !== "true") return;
    const n = this.modalZoomImageContainer.getBoundingClientRect(),
      s = ((e.clientX - n.left) / n.width) * 100,
      c = ((e.clientY - n.top) / n.height) * 100;
    ((this.modalZoomImage.style.transformOrigin = `${s}% ${c}%`),
      (this.modalZoomImage.style.transform = "scale(2)"));
  }
  handleModalImageMouseLeave() {
    this.modalImageContainer.getAttribute("data-zoomed") === "true" &&
      (this.modalImageContainer.setAttribute("data-zoomed", "false"),
      (this.modalImage.style.transformOrigin = "center"),
      (this.modalImage.style.transform = "scale(1)"));
  }
  handleModalClick(e) {
    e.target === this.modal && this.closeModal();
  }
  handleThumbnailClick(e) {
    const s = e.currentTarget.getAttribute("data-image-index");
    this.modalImages
      .find((u) => u.getAttribute("data-image-index") === s)
      .scrollIntoView({ behavior: "smooth", block: "start" });
  }
  handleImageClick(e) {
    var l;
    this.setLazyImages();
    const s = e.currentTarget.querySelector("img");
    if (!this.modal || !this.modalImage) return;
    const c = s.parentElement.getAttribute("data-image-index");
    (this.modal.setAttribute("data-active", "true"),
      document.body.classList.add("modal-open"),
      (document.body.style.overflow = "hidden"),
      this.parentElement.setAttribute("data-gallery-open", "true"),
      this.setActiveThumbnail(c));
    const u = this.modalImages.find(
      (m) => m.getAttribute("data-image-index") === c,
    );
    (u == null || u.scrollIntoView({ behavior: "smooth", block: "start" }),
      (l = this.modalImageContainer) == null ||
        l.setAttribute("data-zoomed", "false"));
  }
  closeModal() {
    var e;
    (this.parentElement.removeAttribute("data-gallery-open"),
      this.modal &&
        (this.modal.setAttribute("data-active", "false"),
        document.body.classList.remove("modal-open"),
        (document.body.style.overflow = ""),
        (e = this.modalImageContainer) == null ||
          e.setAttribute("data-zoomed", "false"),
        (this.modalImage.style.transformOrigin = "center"),
        (this.modalImage.style.transform = "scale(1)")));
  }
  handleModalClose(e) {
    (e.preventDefault(), e.stopPropagation(), this.closeModal());
  }
  initSwipers() {
    if (
      ((this.thumbnailsSwiper = new J(this.thumbnailsSwiperWrapperEl, {
        modules: [de, Pe, he],
        direction: "vertical",
        slidesPerView: "auto",
        spaceBetween: 8,
        freeMode: !0,
        watchSlidesProgress: !0,
        centerInsufficientSlides: !1,
        slideVisibleClass: "swiper-slide-thumb-visible",
      })),
      !this.swiper)
    ) {
      const e = window.innerWidth < 768 ? 1.5 : 5;
      this.swiper = new J(this.mainSwiperWrapperEl, {
        modules: [de, Te, he, Le, Se],
        slidesPerView: 1,
        spaceBetween: 10,
        grabCursor: !0,
        observer: !0,
        observeParents: !0,
        navigation: {
          prevEl: "[data-swiper-prev]",
          nextEl: "[data-swiper-next]",
        },
        pagination: { el: "[data-swiper-pagination]", clickable: !0 },
        uniqueNavElements: !1,
        thumbs: {
          swiper: this.thumbnailsSwiper.swiper,
          slideThumbActiveClass: "swiper-slide-thumb-active",
        },
        loop: !0,
        zoom: { maxRatio: e },
        on: {
          init: () => {
            this.classList.add("initialized");
          },
          slideChange: (n) => {
            (n.pagination && n.pagination.el && n.pagination.update(),
              this.thumbnailsSwiper &&
                this.thumbnailsSwiper.swiper &&
                this.thumbnailsSwiper.swiper.slideToLoop(n.realIndex));
          },
        },
      });
    }
  }
  destroySwiper() {
    this.swiper &&
    this.swiper.swiper &&
    typeof this.swiper.swiper.destroy == "function"
      ? (this.swiper.swiper.destroy(!0, !0), (this.swiper = void 0))
      : console.error(
          "Swiper instance is invalid or destroy method not available",
        );
  }
  handleResize() {
    window.innerWidth > this.mobileBreakpoint
      ? this.destroySwiper()
      : this.swiper || this.initSwipers();
  }
  async handleProductVariantUpdate(e) {
    const { product: n, variant: s } = e.detail,
      c = this.getAttribute("data-product-id");
    if (c && c !== n.id.toString()) return;
    (xe("--mobile-carousel-height", this, this),
      this.classList.add("is-loading"));
    const u = new URL(
        `${window.location.origin}/products/${n.handle}?variant=${s.id}`,
      ),
      l = await Ce.fetch(u, "product-media-gallery"),
      m = Ae(l, "[data-swiper-slide]", !0),
      b = document.createElement("div");
    b.innerHTML = l;
    const M = b.querySelector(".main-product__media-modal-thumbnails");
    if (M) {
      const E = this.querySelector(".main-product__media-modal-thumbnails");
      E &&
        ((E.innerHTML = M.innerHTML),
        (this.modalThumbnails = E.querySelectorAll("[data-modal-thumbnail]")),
        this.modalThumbnails.forEach((x) => {
          x.addEventListener("click", this.handleThumbnailClick);
        }));
    }
    (m.length <= 1
      ? (this.destroySwiper(), this.swiperContainer.replaceChildren(...m))
      : this.swiper
        ? (this.swiper.removeAllSlides(),
          this.swiper.appendSlide(m),
          this.swiper.updateSlides(),
          this.swiper.slideTo(0))
        : (this.swiperContainer.replaceChildren(...m), this.initSwipers()),
      setTimeout(() => {
        this.classList.remove("is-loading");
      }, 300),
      this.querySelectorAll(".product-media-gallery__button").forEach((E) => {
        E.addEventListener("click", this.handleImageClick);
      }));
  }
  async showImage(e) {
    if (e) {
      const n = document.createElement("img");
      ((n.src = e),
        this.variantImageContainerEl.insertAdjacentElement("afterbegin", n));
    } else this.variantImageContainerEl.innerHTML = "";
  }
}
customElements.get("dickies-main-product-standard-gallery") ||
  customElements.define("dickies-main-product-standard-gallery", Ve);
export { Ve as DickiesMainProductStandardGallery };
